import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

//Tables
import MyTable from '../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';

//Utils
import {
    applyMaskAccount,
    applyMaskAmount,
    applyMaskAmountFreeDecimals,
} from '../utils/utils'

import UnoButton from '../utils/UnoButton';

import { Tooltip, Typography } from '@material-ui/core';

import { unoTheme } from '../../assets/styles/unoTheme'

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        alignItems: 'center',
        paddingBottom: theme.spacing(4),
    },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    dialogTitle: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between'
        }

    },

    fundNameTitle: {
        fontSize: '14px',
        fontWeight: 'normal',
        color: unoTheme.secondaryColor,
    },

    labelTopModal: {
        float: 'right',
        fontSize: '14px',
        color: unoTheme.defaultTextColor
    },

    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    blue: {
        color: "blue",
    },

    //Fundo special sem cota cadastrada para o cliente na data: o valor exibido veio
    //do valor_cota padrão do fundo, que nesses fundos costuma ser um placeholder
    missingQuotaRow: {
        background: 'rgba(255, 42, 42, 0.08) !important',

        '& .MuiTableCell-root': {
            color: unoTheme.errorColor + ' !important',
        },
    },

    statusOk: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },

    statusPendent: {
        color: unoTheme.errorColor,
        fill: unoTheme.errorColor,
    },

    emptyMessage: {
        padding: theme.spacing(4),
        color: unoTheme.defaultTextColor,
    },

}));

export default function TransactionsHistoryModal(props) {

    const classes = useStyles();

    const { open, fundName, special, rows,
        handleExcel, handleClose } = props;

    const transactions = rows ? rows : [];

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'lg'}
            open={open}
            PaperProps={{
                style: {
                    height: '90vh',
                },
            }}
            onClose={() => handleClose()}>

            <DialogTitle
                className={classes.dialogTitle}>
                <div>
                    {"Histórico de movimentações"}
                    <Typography className={classes.fundNameTitle}>
                        {fundName}
                    </Typography>
                </div>
                <span className={classes.labelTopModal}>
                    {transactions.length + (transactions.length == 1 ? ' movimentação' : ' movimentações')}
                </span>
            </DialogTitle>

            <DialogContent
                className={classes.contentModal}>

                {
                    transactions.length ?

                        <MyTable
                            style={{ marginTop: '8px' }}
                            stickyHeader
                            sizeheaders="verySmall"
                            size="small">
                            {
                                special ?
                                    <colgroup>
                                        <col width="12%" />
                                        <col width="14%" />
                                        <col width="14%" />
                                        <col width="16%" />
                                        <col width="16%" />
                                        <col width="18%" />
                                        <col width="10%" />
                                    </colgroup>
                                    :
                                    <colgroup>
                                        <col width="13%" />
                                        <col width="16%" />
                                        <col width="16%" />
                                        <col width="18%" />
                                        <col width="18%" />
                                        <col width="19%" />
                                    </colgroup>
                            }

                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Data</TableCell>
                                    <TableCell align="center">Operação</TableCell>
                                    <TableCell align="center">Conta</TableCell>
                                    <TableCell align="right">Qtd. de cotas</TableCell>
                                    <TableCell align="right">Valor de cota no dia</TableCell>
                                    <TableCell align="right">Valor financeiro</TableCell>
                                    {
                                        special ?
                                            <TableCell align="center">Cota do cliente</TableCell>
                                            : null
                                    }
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {
                                    transactions.map((row, index) => (

                                        <TableRow
                                            className={special && !row.hasClientQuota ? classes.missingQuotaRow : null}
                                            key={'transaction-history-' + index}>

                                            <TableCell align="center">
                                                {row.ptDate ? row.ptDate : '-'}
                                            </TableCell>

                                            <TableCell align="center">
                                                {row.operationLabel}
                                            </TableCell>

                                            <TableCell align="center">
                                                {row.numberAccount ? applyMaskAccount(row.numberAccount) : '-'}
                                            </TableCell>

                                            <TableCell align="right">
                                                {row.qtdQuotas != null ? applyMaskAmountFreeDecimals(row.qtdQuotas, null, 7) : '-'}
                                            </TableCell>

                                            <TableCell align="right">
                                                {row.quotaValue != null ? applyMaskAmountFreeDecimals(row.quotaValue, true, 8) : '-'}
                                            </TableCell>

                                            <TableCell align="right" className={
                                                special && !row.hasClientQuota ? null : (
                                                    row.operationId == 1 ? classes.green : (
                                                        row.operationId == 2 ? classes.red : classes.blue
                                                    )
                                                )
                                            }>
                                                {row.amount != null ? applyMaskAmount(row.amount, true) : '-'}
                                            </TableCell>

                                            {
                                                special ?
                                                    <TableCell align="center">
                                                        {
                                                            row.hasClientQuota ?
                                                                <Tooltip
                                                                    title={'Existe cota cadastrada para este cliente em ' + row.ptDate}
                                                                    placement="left" arrow>
                                                                    <CheckCircleIcon className={classes.statusOk} />
                                                                </Tooltip>
                                                                :
                                                                <Tooltip
                                                                    title={'Não há cota cadastrada para este cliente em ' + row.ptDate + ': o valor exibido usa a cota padrão do fundo'}
                                                                    placement="left" arrow>
                                                                    <ReportProblemIcon className={classes.statusPendent} />
                                                                </Tooltip>
                                                        }
                                                    </TableCell>
                                                    : null
                                            }

                                        </TableRow>

                                    ))
                                }
                            </TableBody>

                        </MyTable>

                        :

                        <Typography className={classes.emptyMessage}>
                            {'Nenhuma movimentação encontrada.'}
                        </Typography>
                }

            </DialogContent>

            <DialogActions className={classes.actionsFlex}>

                <UnoButton onClick={() =>
                    handleClose()} color="secondary">
                    {'Fechar'}
                </UnoButton>

                <UnoButton
                    onClick={() => handleExcel()}
                    type='success'>
                    {'Gerar Excel'}
                </UnoButton>

            </DialogActions>

        </Dialog >
    );
}
